import { strokeStyle } from "./stroke";

function ChevronRight({ color = "var(--text-muted)" }) {
  return (
    <svg
      aria-hidden="true"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={strokeStyle(color)}
    >
      <path d="M9 6l6 6-6 6" />
    </svg>
  );
}

export default ChevronRight;
